import { render, staticRenderFns } from "./Inscripcion-add.vue?vue&type=template&id=2a091cb2"
import script from "@/components/inscripcion-add.js?vue&type=script&lang=js&external"
export * from "@/components/inscripcion-add.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports